// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetBase_container__XeCDM","header":"WidgetBase_header__14lqX","title":"WidgetBase_title__2_DcX"};